import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonServiceService } from '../services/common-service.service';
import { environment } from 'src/environments/environment';
import { PRISM_INTRO_FALLBACK_HTML, PRISM_TABLE_SECTION_HTML } from './ipsa-intro-fallback.html';

@Component({
  selector: 'app-ipsa-intro',
  templateUrl: './ipsa-intro.component.html',
  styleUrls: ['./ipsa-intro.component.scss']
})
export class IpsaIntroComponent implements OnInit {

  introHtml = PRISM_INTRO_FALLBACK_HTML;
  introLoading = !!environment.prismIntroSectionId;
  useCmsIntro = false;

  constructor(
    public router: Router,
    private commonService: CommonServiceService
  ) { }

  ngOnInit(): void {
    this.loadPrismIntro();
  }

  loadPrismIntro(): void {
    const sectionId = environment.prismIntroSectionId;
    if (!sectionId) {
      this.introLoading = false;
      return;
    }
    this.introLoading = true;
    this.commonService.getPageDetails(sectionId).subscribe({
      next: (res) => {
        const rows = res?.data || [];
        const row = rows.find((r: { isActive?: boolean }) => r.isActive) ?? rows[0];
        const copy = row?.subTitle?.trim();
        if (res?.success && copy) {
          // If the stored content has no table, append the standard PRISM table section.
          // This handles content saved via the Quill editor (which has no table tool).
          this.introHtml = copy.includes('<table') ? copy : copy + '\n' + PRISM_TABLE_SECTION_HTML;
          this.useCmsIntro = true;
        }
      },
      error: () => {
        this.introLoading = false;
      },
      complete: () => {
        this.introLoading = false;
      },
    });
  }

  backToForm(): void {
    this.router.navigate(['/prism']);
  }

}
